const getTitle = (headline, vertical) => {
  let title = headline.seo || headline.primary;
  if (vertical === 'noticias') {
    title = `${title} | Telemundo`;
  }
  return title;
};

export default getTitle;
